import Vue from "vue";

export default {
    install() {
        // 使用 import.meta.glob (Vite)
        const modules = import.meta.glob('@/components/**/*.vue');
        for (const path in modules) {

            modules[path]().then((module) => {
                Vue.component(module.default.name, module.default);
            });
        }
    }
};

function component(EvComponent) {
    Vue.component(EvComponent.name, EvComponent);
}